import { useForm } from '@inertiajs/vue3'
import { LanguageEnum } from '@/Support/Languages/Interfaces/LanguageEnum'
import { routing } from '@/Support/Routing/Functions/routing'
import { loadLanguageAsync } from 'laravel-vue-i18n'
import { storeToRefs } from 'pinia'
import { useAppLayout } from '@/stores/appLayout'

export function useChangeLanguage() {
  const { currentLocale, currentLanguage } = storeToRefs(useAppLayout())

  interface Form {
    language: string
  }

  const form = useForm<Form>({
    language: currentLanguage.value,
  })

  const update = (language: LanguageEnum | string) => {
    form.language = typeof language === 'string' ? language : language.value
  }

  const change = () => {
    form.put(routing('settings.languages.update'), {
      preserveScroll: true,
      preserveState: false,
      onSuccess: () => {
        loadLanguageAsync(currentLocale.value)
      },
    })
  }

  const updateAndChange = (language: LanguageEnum | string) => {
    update(language)
    change()
  }

  return {
    form,
    update,
    change,
    updateAndChange,
  }
}
